import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { CSRD } from "../../../api";

export const CSRDKeys = {
  allCSRDQuestionnaires: () => ["allCSRDQuestionnaires"],
  CSRDQuestionnaireById: () => ["CSRDQuestionnaireById"],
  CSRDQuestionsByType: () => ["CSRDQuestionsByType"],
  CSRDQuestionnaireDataComments: () => ["CSRDQuestionnaireDataComments"],
  allCSRDAnswersByQuestionId: () => ["allCSRDAnswersByQuestionId"],
  CSRDReport: () => ["CSRDReport"],
  CSRDFiles: () => ["CSRDFiles"],
  CSRDProgressByYear: () => ["CSRDProgressByYear"]
};

export function useGetAllCSRDQuestionnaires(queryParams, config) {
  const { callApi } = useAuth();
  return useQuery([...CSRDKeys.allCSRDQuestionnaires(), queryParams],
    () => callApi(CSRD.getAllCSRDQuestionnaires, queryParams), config);
}

export function useCreateCSRDQuestionnaire(config) {
  const { callApi } = useAuth();
  return useMutation(data => callApi(CSRD.createCSRDQuestionnaire, data), config);
}

export function useUpdateCSRDQuestionnaire(config) {
  const { callApi } = useAuth();
  return useMutation(({ id, data }) =>
    callApi(CSRD.updateCSRDQuestionnaire, { id, data }), config);
}

export function useDeleteCSRDQuestionnaire(config) {
  const { callApi } = useAuth();
  return useMutation(id => callApi(CSRD.deleteCSRDQuestionnaire, id), config);
}

export function useFinaliseCSRDQuestionnaire(config) {
  const { callApi } = useAuth();
  return useMutation(id => callApi(CSRD.finaliseCSRDQuestionnaire, id), config);
}

export function useUnfinaliseCSRDQuestionnaire(config) {
  const { callApi } = useAuth();
  return useMutation(questionnaireId =>
    callApi(CSRD.unfinaliseCSRDQuestionnaire, questionnaireId), config
  );
}

export function useGetCSRDQuestionnaireDataById(id, config) {
  const { callApi } = useAuth();
  return useQuery([...CSRDKeys.CSRDQuestionnaireById(), id],
    () => callApi(CSRD.getCSRDQuestionnaireDataById, id), config);
}

export function useUpdateCSRDQuestionnaireDataById(config) {
  const { callApi } = useAuth();
  return useMutation(({ id, data }) =>
    callApi(CSRD.updateCSRDQuestionnaireDataById, { id, data }), config);
}

export function useGetCSRDQuestionnaireDataComments(params, config) {
  const { callApi } = useAuth();
  return useQuery([...CSRDKeys.CSRDQuestionnaireDataComments(), params],
    () => callApi(CSRD.getCSRDQuestionnaireDataComments, params), config);
}

export function useGetCSRDReport(params, config) {
  const { callApi } = useAuth();
  return useQuery([...CSRDKeys.CSRDReport(), params],
    () => callApi(CSRD.getCSRDReport, params), config);
}

export function useGetAllCSRDAnswersByQuestionId(params, config) {
  const { callApi } = useAuth();
  return useQuery([...CSRDKeys.allCSRDAnswersByQuestionId(), params],
    () => callApi(CSRD.getAllCSRDAnswersByQuestionId, params), config);
}

export function useGetCSRDQuestionsByType(params, config) {
  const { callApi } = useAuth();
  return useQuery([...CSRDKeys.CSRDQuestionsByType(), params],
    () => callApi(CSRD.getCSRDQuestionsByType, params), config);
}

export function useGetCSRDFiles(params, config) {
  const { callApi } = useAuth();
  return useQuery([...CSRDKeys.CSRDFiles(), params],
    () => callApi(CSRD.getCSRDFiles, params), config);
}

export function useAttachCSRDFile(config) {
  const { callApi } = useAuth();
  return useMutation(({ type, year, data }) =>
    callApi(CSRD.attachCSRDFile, { type, year, data }), config);
}

export function useExportCSRDReport(config) {
  const { callApi } = useAuth();
  return useMutation(({ params }) => callApi(CSRD.exportCSRDReport, params), config);
}

export function useGetCSRDProgressByYear(params, config) {
  const { callApi } = useAuth();
  return useQuery([...CSRDKeys.CSRDProgressByYear(), params],
    () => callApi(CSRD.getCSRDProgressByYear, params), config);
}